// content.js
// Data for the /santas-ai-lab page. The milestone list mirrors the public
// journey section on santasailab.com: eleven products over thirty-three months,
// authored newest first. Stella deliberately appears as two milestones (V1 for
// seniors, V2 for the Hasidic Jewish market) because it was rebuilt, not
// iterated. Keep this list and santasailab.com in agreement.

import icebergLogo from '../../Assets/santas_ai_lab/iceberg.png';
import mixmatchLogo from '../../Assets/santas_ai_lab/mixmatch.png';
import untangleLogo from '../../Assets/santas_ai_lab/untangle.png';
import flockLogo from '../../Assets/santas_ai_lab/flock.png';
import taginLogo from '../../Assets/santas_ai_lab/tagin-live.png';
import healthGcLogo from '../../Assets/santas_ai_lab/health-gc.svg';
import modernFdaLogo from '../../Assets/santas_ai_lab/modern-fda.png';
import myDrScoutLogo from '../../Assets/santas_ai_lab/mydrscout.svg';
import formNumberLogo from '../../Assets/santas_ai_lab/form-number-icon.png';
import stellaFosterLogo from '../../Assets/career_logos/stella_foster_logo.svg';
import outsideAgentLogo from '../../Assets/career_logos/outside_agent_logo.png';

export const MILESTONES = [
    {
        id: 'form-number',
        title: 'Form Number',
        date: 'Jul 2026',
        status: 'live',
        summary: 'An AI intake specialist with its own phone number.',
        url: 'https://formnumber.com/',
        image: formNumberLogo,
        background: '#edf5e9',
    },
    {
        id: 'outside-agent',
        title: 'Outside Agent',
        date: 'Early 2026',
        status: 'live',
        summary: 'Infrastructure for reliable phone, SMS, and web agents.',
        url: 'https://outsideagent.ai/',
        image: outsideAgentLogo,
        background: '#e8f1df',
    },
    {
        id: 'stella-v2',
        title: 'Stella V2',
        date: '2026',
        status: 'Hasidic Jewish market',
        summary: 'Stella rebuilt to serve the needs of the Hasidic Jewish market.',
        url: 'https://stellafoster.com/',
        image: stellaFosterLogo,
        background: '#e8eef8',
    },
    {
        id: 'stella-v1',
        title: 'Stella V1',
        date: 'Late 2025',
        status: 'seniors',
        summary: 'A phone-and-text AI assistant designed to make AI accessible to seniors.',
        url: 'https://ktla.com/news/how-a-phone-call-is-helping-seniors-use-ai/',
        image: stellaFosterLogo,
        background: '#f1f3f7',
    },
    {
        id: 'mydrscout',
        title: 'myDrScout',
        date: 'Late 2024',
        status: 'archived',
        summary: 'Help people find the right doctor for a specific concern.',
        url: 'https://santasailab.com/archive/mydrscout/',
        image: myDrScoutLogo,
        background: '#f1f0ed',
    },
    {
        id: 'modern-fda',
        title: 'Modern FDA',
        date: 'Late 2024',
        status: 'archived',
        summary: 'A clearer, friendlier way to explore and understand FDA data.',
        url: 'https://santasailab.com/archive/modern-fda/',
        image: modernFdaLogo,
        background: '#edf7ff',
    },
    {
        id: 'health-gc',
        title: 'Health GC',
        date: 'Late 2024',
        status: 'archived',
        summary: 'A personal general contractor for navigating healthcare.',
        url: 'https://santasailab.com/archive/health-gc/',
        image: healthGcLogo,
        background: '#fff7e8',
    },
    {
        id: 'tagin',
        title: 'Tagin',
        date: 'Late 2024',
        status: 'archived',
        summary: 'Hand off the calls and hold times that make healthcare exhausting.',
        url: 'https://santasailab.com/archive/tagin/',
        image: taginLogo,
        background: '#111827',
    },
    {
        id: 'flock',
        title: 'Flock',
        date: 'Jun 2024',
        status: 'archived',
        summary: 'Turn a voice conversation into a researched newsletter.',
        url: 'https://santasailab.com/archive/flock/',
        image: flockLogo,
        background: '#eef0ff',
    },
    {
        id: 'untangle',
        title: 'Untangle',
        date: '2024',
        status: 'archived',
        summary: 'A voice-first writing companion for emails, reports, and essays.',
        url: 'https://santasailab.com/archive/untangle/',
        image: untangleLogo,
        background: '#05070a',
    },
    {
        id: 'mixmatch',
        title: 'MixMatch',
        date: 'May 2024',
        status: 'archived',
        summary: 'Face blending, celebrity matching, and playful image transformations.',
        url: 'https://santasailab.com/archive/mixmatch/',
        image: mixmatchLogo,
        background: '#eef2b1',
    },
    {
        id: 'iceberg',
        title: 'Iceberg AI',
        date: 'Nov 2023',
        status: 'first experiment',
        summary: 'An AI-native messenger for themed chats and shared identity.',
        url: 'https://myiceberg.ai/',
        image: icebergLogo,
        background: '#49aef3',
    },
];

// Static thumbnails rather than iframe embeds, matching the landing page: the
// embeds were removed deliberately to keep the page light.
export const VIDEOS = [
    {
        id: '9A_XzdV3gNA',
        title: 'Seniors Want AI',
        event: 'LA Tech Week · October 2025',
    },
    {
        id: 'Vg3E2rx8pzY',
        title: 'OpenAI Voice Hackathon Demo',
        event: 'Cerebral Valley · May 2026',
    },
    {
        id: 'xs5oX_i78ZA',
        title: 'Flock, a newsletter you talk into',
        event: 'Product demo · 2024',
    },
];
